@let canCreateScenario =
  meFeature.contexts.selectors.currentUserCanCreateScenario.asSignal();
@let sections = scenariosFeature.selectors.sections.asSignal();

<div class="atn-scenario-dropdown-overlay">
  <div class="atn-scenario-dropdown-overlay__header">
    <div class="atn-scenario-dropdown-overlay__header-name">Scenarios</div>
    @if (canCreateScenario) {
      <div
        class="atn-scenario-dropdown-overlay__header-add-btn"
        (click)="addBtnClickedHandler()"
      >
        <i class="atn-icon atn-blue atn-plus"></i>
      </div>
    }
  </div>
  @for (section of sections; track $index) {
    <atn-scenario-dropdown-overlay-section [section]="section" />
  }
</div>
